import React, { useState } from "react";

import { InputField } from "../../ppui";
import { logger } from "../../utils/logger.js";
import { TbSearch } from "react-icons/tb";

const SearchBox = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchQuery(value);

    if (value.length >= 2) {
      logger.log(`Search Query: ${value}`); // Log the search query to the console
      onSearch(value); // Pass the search query back to the parent component if it has 3 or more characters
    } else {
      onSearch(""); // Clear search results if input is less than 3 characters
    }
  };

  return (
    <InputField
      variant="standard"
      type="search"
      suffix={<TbSearch />}
      placeholder="Search..."
      value={searchQuery}
      onChange={handleSearchChange}
    />
  );
};

export default SearchBox;
